import styled from 'styled-components'

export const Loader = styled('div')`
  display: flex;
  alignItems: center;
  justifyContent: center;
`;